import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { isInPage } from '@beef/utils';
var scrollToBlock = function scrollToBlock(elementId) {
  var scrollParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    block: 'start',
    behavior: 'smooth'
  };
  if (window !== undefined && isInPage(document.getElementById(elementId))) {
    document.getElementById(elementId).scrollIntoView(scrollParams);
  }
};
export default scrollToBlock;
export var windowScrollToBlock = function windowScrollToBlock(elementId) {
  var scrollParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    behavior: 'smooth'
  };
  if (window !== undefined && isInPage(document.getElementById(elementId))) {
    var headerHeight = document.querySelector('header').offsetHeight || 0;
    var elementOffsetTop = document.getElementById(elementId).offsetTop || 0;
    var baseOffset = 20;
    var scrollValue = elementOffsetTop - headerHeight - baseOffset;
    window.scrollTo(_objectSpread({
      top: scrollValue
    }, scrollParams));
  }
};